import './bar_loader.css';

export function BarLoader() {
    return (
        <div className="bar_loader"></div>
    );
}